import * as React from "react";
import Box from "@mui/material/Box";
import { useSelector } from "react-redux";
import { styled } from "@mui/material/styles";
import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress";

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 10,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor:
      theme.palette.grey[theme.palette.mode === "light" ? 200 : 800],
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 55,
    height: 10,
    backgroundColor: theme.palette.mode === "light" ? "#1a90ff" : "#308fe8",
  },
}));

function Loading() {
  //addons
  const listAddons = useSelector((state) => state.listAddons);
  const { loading: listAddonsLoading } = listAddons;

  const singleAddons = useSelector((state) => state.singleAddons);
  const { loading: singleAddonsLoading } = singleAddons;

  // const addonCreate = useSelector((state) => state.addonCreate);
  // const { loading: addonCreateLoading } = addonCreate;

  // const addonUpdate = useSelector((state) => state.addonUpdate);
  // const { loading: addonUpdateLoading } = addonUpdate;

  // const addonDelete = useSelector((state) => state.addonDelete);
  // const { loading: addonDeleteLoading } = addonDelete;

  // Categories also all go here
  const listCategories = useSelector((state) => state.listCategories);
  const { loading: listCategoriesLoading } = listCategories;

  // const categoryPost = useSelector((state) => state.categoryPost);
  // const { loading: categoryPostLoading } = categoryPost;

  // const updateCategory = useSelector((state) => state.updateCategory);
  // const { loading: updateCategoryLoading } = updateCategory;

  // const deleteCategory = useSelector((state) => state.deleteCategory);
  // const { loading: deleteCategoryLoading } = deleteCategory;

  // Claims
  const myListClaim = useSelector((state) => state.myListClaim);
  const { loading: myListClaimLoading } = myListClaim;

  const singleClaim = useSelector((state) => state.singleClaim);
  const { loading: singleClaimLoading } = singleClaim;

  const pendingClaims = useSelector((state) => state.pendingClaims);
  const { loading: pendingClaimsLoading } = pendingClaims;

  const postClaim = useSelector((state) => state.postClaim);
  const { loading: postClaimLoading } = postClaim;

  const updateClaims = useSelector((state) => state.updateClaims);
  const { loading: updateClaimsLoading } = updateClaims;

  const deleteClaims = useSelector((state) => state.deleteClaims);
  const { loading: deleteClaimsLoading } = deleteClaims;

  // Claims Requirements
  const listClaimRequirements = useSelector(
    (state) => state.listClaimRequirements
  );
  const { loading: listClaimRequirementsLoading } = listClaimRequirements;

  const singleClaimRequirements = useSelector(
    (state) => state.singleClaimRequirements
  );
  const { loading: singleClaimRequirementsLoading } = singleClaimRequirements;

  // const claimRequirementCreate = useSelector(
  //   (state) => state.claimRequirementCreate
  // );
  // const { loading: claimRequirementCreateLoading } = claimRequirementCreate;

  // const claimRequirementUpdate = useSelector(
  //   (state) => state.claimRequirementUpdate
  // );
  // const { loading: claimRequirementUpdateLoading } = claimRequirementUpdate;

  // const claimRequirementDelete = useSelector(
  //   (state) => state.claimRequirementDelete
  // );
  // const { loading: claimRequirementDeleteLoading } = claimRequirementDelete;

  // Clients
  const listClients = useSelector((state) => state.listClients);
  const { loading: listClientsLoading } = listClients;

  const singleClient = useSelector((state) => state.singleClient);
  const { loading: singleClientLoading } = singleClient;

  const createClient = useSelector((state) => state.createClient);
  const { loading: createClientLoading } = createClient;

  const updateClient = useSelector((state) => state.updateClient);
  const { loading: updateClientLoading } = updateClient;

  const deleteClient = useSelector((state) => state.deleteClient);
  const { loading: deleteClientLoading } = deleteClient;

  // Company
  const listCompanies = useSelector((state) => state.listCompanies);
  const { loading: listCompaniesLoading } = listCompanies;

  const singleCompanies = useSelector((state) => state.singleCompanies);
  const { loading: singleCompaniesLoading } = singleCompanies;

  // const companiesPost = useSelector((state) => state.companiesPost);
  // const { loading: companiesPostLoading } = companiesPost;

  // const updateCompanies = useSelector((state) => state.updateCompanies);
  // const { loading: updateCompaniesLoading } = updateCompanies;

  // const deleteCompanies = useSelector((state) => state.deleteCompanies);
  // const { loading: deleteCompaniesLoading } = deleteCompanies;

  // Info
  const paymentInfo = useSelector((state) => state.paymentInfo);
  const { loading: paymentInfoLoading } = paymentInfo;

  // Orders
  const myListOrders = useSelector((state) => state.myListOrders);
  const { loading: myListOrdersLoading } = myListOrders;

  const statsOrders = useSelector((state) => state.statsOrders);
  const { loading: statsOrdersLoading } = statsOrders;

  const orderSingle = useSelector((state) => state.orderSingle);
  const { loading: orderSingleLoading } = orderSingle;

  const createOrder = useSelector((state) => state.createOrder);
  const { loading: createOrderLoading } = createOrder;

  const updateOrder = useSelector((state) => state.updateOrder);
  const { loading: updateOrderLoading } = updateOrder;

  const deleteOrder = useSelector((state) => state.deleteOrder);
  const { loading: deleteOrderLoading } = deleteOrder;

  const listIncompleteOrders = useSelector(
    (state) => state.listIncompleteOrders
  );
  const { loading: listIncompleteOrdersLoading } = listIncompleteOrders;

  const listApprovedOrders = useSelector((state) => state.listApprovedOrders);
  const { loading: listApprovedOrdersLoading } = listApprovedOrders;

  const listShippingOrder = useSelector((state) => state.listShippingOrder);
  const { loading: listShippingOrderLoading } = listShippingOrder;

  const listDeliveriesOrders = useSelector(
    (state) => state.listDeliveriesOrders
  );
  const { loading: listDeliveriesOrdersLoading } = listDeliveriesOrders;

  // Policies
  const listPolicies = useSelector((state) => state.listPolicies);
  const { loading: listPoliciesLoading } = listPolicies;

  const statsPolicies = useSelector((state) => state.statsPolicies);
  const { loading: statsPoliciesLoading } = statsPolicies;

  const searchPolicies = useSelector((state) => state.searchPolicies);
  const { loading: searchPoliciesLoading } = searchPolicies;

  const singlePolicy = useSelector((state) => state.singlePolicy);
  const { loading: singlePolicyLoading } = singlePolicy;

  const listPoliciesPerCategory = useSelector(
    (state) => state.listPoliciesPerCategory
  );
  const { loading: listPoliciesPerCategoryLoading } = listPoliciesPerCategory;

  // Policy Requirements
  const listPolicyRequirements = useSelector(
    (state) => state.listPolicyRequirements
  );
  const { loading: listPolicyRequirementsLoading } = listPolicyRequirements;

  const singlePolicyRequirements = useSelector(
    (state) => state.singlePolicyRequirements
  );
  const { loading: singlePolicyRequirementsLoading } = singlePolicyRequirements;

  // const policyRequirementCreate = useSelector(
  //   (state) => state.policyRequirementCreate
  // );
  // const { loading: policyRequirementCreateLoading } = policyRequirementCreate;

  // const policyRequirementUpdate = useSelector(
  //   (state) => state.policyRequirementUpdate
  // );
  // const { loading: policyRequirementUpdateLoading } = policyRequirementUpdate;

  // const policyRequirementDelete = useSelector(
  //   (state) => state.policyRequirementDelete
  // );
  // const { loading: policyRequirementDeleteLoading } = policyRequirementDelete;

  // Transactions
  const myListTransactions = useSelector((state) => state.myListTransactions);
  const { loading: myListTransactionsLoading } = myListTransactions;

  const statsTransactions = useSelector((state) => state.statsTransactions);
  const { loading: statsTransactionsLoading } = statsTransactions;

  const incompleteTransactions = useSelector(
    (state) => state.incompleteTransactions
  );
  const { loading: incompleteTransactionsLoading } = incompleteTransactions;

  const orderTransaction = useSelector((state) => state.orderTransaction);
  const { loading: orderTransactionLoading } = orderTransaction;

  const singleTransaction = useSelector((state) => state.singleTransaction);
  const { loading: singleTransactionLoading } = singleTransaction;

  const createTransaction = useSelector((state) => state.createTransaction);
  const { loading: createTransactionLoading } = createTransaction;

  const updateTransaction = useSelector((state) => state.updateTransaction);
  const { loading: updateTransactionLoading } = updateTransaction;

  const deleteTransaction = useSelector((state) => state.deleteTransaction);
  const { loading: deleteTransactionLoading } = deleteTransaction;

  // User / Admin
  const listUsers = useSelector((state) => state.listUsers);
  const { loading: listUsersLoading } = listUsers;

  const singleUser = useSelector((state) => state.singleUser);
  const { loading: singleUserLoading } = singleUser;

  const createUser = useSelector((state) => state.createUser);
  const { loading: createUserLoading } = createUser;

  const updateUser = useSelector((state) => state.updateUser);
  const { loading: updateUserLoading } = updateUser;

  const deleteUser = useSelector((state) => state.deleteUser);
  const { loading: deleteUserLoading } = deleteUser;

  // Company Stats
  const overallCompanyStats = useSelector((state) => state.overallCompanyStats);
  const { loading: companyStatsOverallLoading } = overallCompanyStats;

  const statsByAge = useSelector((state) => state.statsByAge);
  const { loading: ageStatsLoading } = statsByAge;

  const statsClientsJoinedPerMonth = useSelector(
    (state) => state.statsClientsJoinedPerMonth
  );
  const { loading: clientsJoinedPerMonthLoading } = statsClientsJoinedPerMonth;

  return (
    <Box sx={{ width: "100%" }}>
      {listAddonsLoading ||
      singleAddonsLoading ||
      listCategoriesLoading ||
      myListClaimLoading ||
      singleClaimLoading ||
      pendingClaimsLoading ||
      postClaimLoading ||
      updateClaimsLoading ||
      deleteClaimsLoading ||
      listClaimRequirementsLoading ||
      singleClaimRequirementsLoading ||
      listClientsLoading ||
      singleClientLoading ||
      createClientLoading ||
      updateClientLoading ||
      deleteClientLoading ||
      listCompaniesLoading ||
      singleCompaniesLoading ||
      paymentInfoLoading ||
      myListOrdersLoading ||
      statsOrdersLoading ||
      orderSingleLoading ||
      createOrderLoading ||
      updateOrderLoading ||
      deleteOrderLoading ||
      listIncompleteOrdersLoading ||
      listApprovedOrdersLoading ||
      listShippingOrderLoading ||
      listDeliveriesOrdersLoading ||
      listPoliciesLoading ||
      statsPoliciesLoading ||
      searchPoliciesLoading ||
      singlePolicyLoading ||
      listPoliciesPerCategoryLoading ||
      listPolicyRequirementsLoading ||
      singlePolicyRequirementsLoading ||
      myListTransactionsLoading ||
      statsTransactionsLoading ||
      incompleteTransactionsLoading ||
      orderTransactionLoading ||
      singleTransactionLoading ||
      createTransactionLoading ||
      updateTransactionLoading ||
      deleteTransactionLoading ||
      listUsersLoading ||
      singleUserLoading ||
      createUserLoading ||
      updateUserLoading ||
      deleteUserLoading ||
      companyStatsOverallLoading ||
      ageStatsLoading ||
      clientsJoinedPerMonthLoading ? (
        <BorderLinearProgress variant="indeterminate" />
      ) : null}
    </Box>
  );
}

export default Loading;
